module.exports = __webpack_public_path__ + "fonts/700-normal-latin.e45478d.woff2";